import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot} from '@angular/router';
import {AuthService} from '../_service/auth.service';
import { AlertifyService } from '../_service/alertify.service';
import { MatDialog } from '@angular/material';
import { LoginComponent } from '../login/login.component';


@Injectable({
    providedIn: 'root'
})

export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
        private alertify: AlertifyService) {}

        canActivate(next: ActivatedRouteSnapshot): boolean {
            if (this.authService.decodedToken) {

                if (next.firstChild !== null) {
                    const roles = next.firstChild.data['roles'] as Array<string>;
                     if (roles) {
                        const match = this.authService.roleFromToken(roles);
                        if (match) {
                            return true;
                        } else {
                            this.router.navigate(['/search']);
                            this.alertify.message('You do not have the necessary permission to access this page.');
                            return false;
                        }
                    }
                }
                this.router.navigate(['/search']);
                return false;
            } else {
                this.router.navigate(['/search']);
                this.authService.logout();
                this.alertify.message('Login required.');
            }
        }
}